import { FC, useContext, useEffect } from "react";
// import Emptymiddleware from '../middlewares/Emptymiddleware'
import TokenMiddlewareTable from "./Tokenmiddleware";

import { TableInputProps } from "../Table";

import store from "../../../store/store";
import { removeBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";
import { GENERAL } from "../config/Transaction/ProductGeneralConf";
import { useSelector } from "react-redux";
import { fetchAllBrands } from "../reducer/brandSlice";
import { resetAddBrandRes } from "../reducer/brandSlice";
import { reset } from "../../EditBrand/reducer/brandDetailsSlice";

const InitMiddlewareTable: FC<TableInputProps> = (props) => {
  const { categoryData } = useSelector((state: any) => state.rootReducer.brand);
  const { entityData, done } = useSelector((state: any) => state.DeletePopup);

  console.log("done", done);

  useEffect(() => {
    store.dispatch(fetchAllBrands(null));
  }, []);

  useEffect(() => {
    store.dispatch(removeBreadcrumb());
  }, []);

  useEffect(() => {
    store.dispatch(reset());
  }, []);

  useEffect(() => {
    if (done) {
      store.dispatch(fetchAllBrands(null));
    }
  }, [done]);

  useEffect(() => {
    store.dispatch(resetAddBrandRes()); // Reset addOfferRes after navigation
  }, []);

  return <TokenMiddlewareTable {...props} />;
};

export default InitMiddlewareTable;
